import './Header.scoped.scss';
import { ReactComponent as FullScreenIcon } from '../../../assets/icons/full-screen.svg';

const Header: React.FC<{ children?: React.ReactNode; title: string; showFullScreen: boolean }> = ({
  title,
  children,
  showFullScreen = false,
}) => {
  function openFullscreen() {
    const elem = document.getElementById('live-class-main-window');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
  }

  return (
    <div className="header-container">
      <div className="class-title">
        <h3>{title}</h3>
      </div>

      <div className="class-info">
        {children}
        <div className="icon">
          {showFullScreen ?? 'hello'}
          {showFullScreen === true ? (
            <FullScreenIcon
              className="image-responsive"
              onClick={() => {
                openFullscreen();
              }}
            />
          ) : (
            ''
          )}
        </div>
        {/* <div> */}
        {/*    <ClockIcon style={{color: '#F04F48', marginRight: 7}}/> */}
        {/*    <p>8 mins left</p> */}
        {/* </div> */}

        {/* <div> */}
        {/*    <CardDropDown/> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Header;
